import { render, staticRenderFns } from "./AddEditCredits.vue?vue&type=template&id=6eb36a6a&scoped=true"
import script from "./AddEditCredits.vue?vue&type=script&lang=js"
export * from "./AddEditCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb36a6a",
  null
  
)

export default component.exports